import React from "react";

export const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <p>&copy; 2024 Kamsu Ravi Teeja-Portolio. All rights reserved.</p>
      </div>
    </footer>
  );
};
